import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MAT_DIALOG_DATA, MatAutocompleteModule, MatDialogModule, MatDialogRef, MatIconModule, MatInputModule, MatRadioModule } from '@angular/material';
import { LayoutModule, SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { SupplierRoutingModule } from '@inventory/components/supplier';
import { NgxPrintModule } from 'ngx-print';
import { SupplierReturnScanComponent } from './supplier-return-scan';
import { SupplierReturnStockItemModalComponent } from './supplier-return-stock-item-modal/supplier-return-stock-item-modal.component';
import { supplierRoutingDeclarationComponents } from './supplier-routing.module';
@NgModule({
  declarations: [...supplierRoutingDeclarationComponents],
  imports: [
    CommonModule,
    SupplierRoutingModule,
    LayoutModule,
    MatRadioModule,
    MatInputModule,
    MatDialogModule,
    MatIconModule,
    MatAutocompleteModule,
    SharedModule,
    NgxPrintModule,
  ],
  providers: [
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: {} }
  ],
  entryComponents: [SupplierReturnStockItemModalComponent, SupplierReturnScanComponent]
})
export class SupplierModule { }